import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  addTravelGuide,
  createCategory,
  createDoorList,
  getAllCity,
  getBnbList,
  getCategoriesOfCity,
  uploadFile,
} from '../../helper/backend_helper';
import InfoTooltip from '../InfoTooltip';

const AddTravelGuide = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  console.log('formData', formData.profileImage);

  const [city, setCity] = useState('');
  const [category, setCategory] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [address, setAddress] = useState('');
  const [location, setLocation] = useState('');
  // const [italianName, setItalianName] = useState('');
  const [italianDescription, setItalianDescription] = useState('');
  // const [italianAddress, setItalianAddress] = useState('');

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);

  async function fetchData() {
    try {
      const usersResponse = await getAllCity();
      // setCities(usersResponse?.data?.data);
      setCities(
        usersResponse?.data?.data?.sort((a, b) => {
          const nameA = a.name?.toLowerCase() || ''; // Handle undefined or null values
          const nameB = b.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB); // Sort alphabetically
        })
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangeCity = async (event) => {
    try {
      const response = await getCategoriesOfCity(event.target.value);
      console.log(response);
      setCategories(response?.data?.data);
      setCity(event.target.value);
      setCategory('');
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      if (!formData.profileImage) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Image is required',
        });
        setLoading(false);
        return;
      }

      if (!city) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'City is required',
        });
        setLoading(false);
        return;
      }

      if (!category) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Category is required',
        });
        setLoading(false);
        return;
      }

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }

      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }

      if (!address) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Address is required',
        });
        setLoading(false);
        return;
      }

      if (!location) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Location is required',
        });
        setLoading(false);
        return;
      }

      // if (!italianName) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: 'Italian name is required',
      //   });
      //   setLoading(false);
      //   return;
      // }

      if (!italianDescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      // if (!italianAddress) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: 'Italian Address is required',
      //   });
      //   setLoading(false);
      //   return;
      // }

      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const data = new FormData();
      data.append('file', formData.profileImage);

      const imageUploadResponse = await uploadFile(data, headers);

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed');
      }

      const Categorydata = {
        image: imageUploadResponse?.data?.data?.fileName,
        city,
        category,
        name,
        address,
        description,
        phoneNo,
        location,
        // italianName,
        italianDescription,
        // italianAddress,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await addTravelGuide(Categorydata, Categoryheaders);

      setFormData({
        ...formData,
        profileImage: null,
      });
      setCity('');
      setCategory('');
      setName('');
      setDescription('');
      setPhoneNo('');
      setAddress('');
      setLocation('');
      // setItalianAddress('');
      setItalianDescription('');
      // setItalianName('');
      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Travel Guide created successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };
  return (
    <>
      <Helmet>
        <title> Add Travel Guide </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Travel Guide</Typography>
        </Stack>

        <Box component="form" add_travelGuide noValidate autoComplete="off">
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>City <InfoTooltip title="City this travel guide entry belongs to. Determines which guests see it and which categories are available." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={city}
                  // label="BnB"
                  onChange={handleChangeCity}
                >
                  {cities?.map((user) => (
                    <MenuItem key={user._id} value={user.name}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>Category <InfoTooltip title="Group this place falls under (e.g. Restaurants, Beaches), used to organize guide entries for guests." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={category}
                  // label="BnB"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  {categories?.map((user) => (
                    <MenuItem key={user._id} value={user.categoryName}>
                      {user.categoryName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          </Stack>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="Name of the place or attraction as guests will see it in the travel guide." /></FormLabel>
              <TextField
                label="Enter Name"
                id="outlined-size-small"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Address <InfoTooltip title="Street address of this place, shown to guests so they can find it." /></FormLabel>
              <TextField
                label="Enter Address"
                id="outlined-size-small"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Stack>
            {/* <Stack>
              <FormLabel sx={{ mb: 1 }}>Italian Name</FormLabel>
              <TextField
                label="Enter Italian Name"
                id="outlined-size-small"
                value={italianName}
                onChange={(e) => setItalianName(e.target.value)}
              />
            </Stack> */}
          </Stack>

          {/* <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap"> */}

          {/* <Stack>
              <FormLabel sx={{ mb: 1 }}>Address</FormLabel>
              <TextField
                label="Enter Address"
                id="outlined-size-small"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </Stack> */}

          {/* <Stack>
              <FormLabel sx={{ mb: 1 }}>Italian Address</FormLabel>
              <TextField
                label="Enter Italian Address"
                id="outlined-size-small"
                value={italianAddress}
                onChange={(e) => setItalianAddress(e.target.value)}
              />
            </Stack> */}
          {/* </Stack> */}

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Phone No <InfoTooltip title="Optional contact number for this place, so guests can call to book or ask questions." /></FormLabel>
              <TextField
                label="Enter Phone No"
                id="outlined-size-small"
                value={phoneNo}
                onChange={(e) => setPhoneNo(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>location <InfoTooltip title="Map link or coordinates for this place, used to point guests to it on a map." /></FormLabel>
              <TextField
                label="Enter location"
                id="outlined-size-small"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Description <InfoTooltip title="English description of this place shown to guests in the travel guide." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Description"
                id="outlined-size-small"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Italian Description <InfoTooltip title="Italian translation of the description, shown to Italian-speaking guests." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Italian Description"
                id="outlined-size-small"
                value={italianDescription}
                onChange={(e) => setItalianDescription(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {formData.profileImage && (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>

        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddTravelGuide;
